import React, { useState } from 'react';
import { Navigate } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import { clearAuthSession, getStoredToken, isTokenExpired } from '../../utils/authSession';

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const token = getStoredToken();

  if (!token || isTokenExpired(token)) {
    clearAuthSession();
    return <Navigate to="/login?session=expired" replace />;
  }

  return (
    <div className="h-screen bg-[#f5f7fa] flex flex-col overflow-hidden">
      {/* Full-width Header - Sticky at top */}
      <Header />

      <div className="flex gap-6 p-6 flex-1 overflow-hidden">
        {/* Sidebar - Fixed with space around */}
        <div className="w-[280px] shrink-0 flex flex-col">
          <div className={`${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} fixed inset-y-0 left-0 z-50 w-[280px] transform transition-transform duration-300 ease-in-out lg:hidden`}>
            <div className="flex items-center justify-between p-4 bg-white">
              <span className="text-xl font-bold text-gray-900">Menu</span>
              <button 
                onClick={() => setSidebarOpen(false)}
                className="p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
            <Sidebar />
          </div>
          <div className="hidden lg:block h-full">
            <Sidebar />
          </div>
        </div>

        {/* Mobile sidebar overlay */}
        {sidebarOpen && (
          <div 
            className="fixed inset-0 z-40 bg-black bg-opacity-50 lg:hidden"
            onClick={() => setSidebarOpen(false)}
          />
        )}

        {/* Main Content Area - Scrollable */}
        <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
          {/* Mobile menu button */}
          <div className="lg:hidden mb-4">
            <button 
              onClick={() => setSidebarOpen(true)}
              className="p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>

          {/* Page Content - Scrollable */}
          <main className="flex-1 overflow-y-auto custom-scrollbar">
            {children}
          </main>
        </div>
      </div>

      {/* Full-width Footer - Sticky at bottom */}
      {/* <Footer /> */}
    </div>
  );
};

export default Layout;